import "./Navbar.css";
import React from "react";
import Navbar from 'react-bootstrap/Navbar';
import Nav from "react-bootstrap/Nav";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, NavDropdown } from "react-bootstrap";
import { NavDropdownMenu } from "react-bootstrap-submenu";
import Logo from "../Images/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

export const NavigationBar = () => {
  return (
    <>
      <Navbar className="custom-sticky-navbar" collapseOnSelect expand="xl" bg="light" variant="light">

        <Navbar.Brand href="/"><img src={Logo} height={'30px'} style={{ paddingLeft: '20px' }} /></Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{ paddingLeft: '40px' }} />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link className="nav-links" href="/"  >Home</Nav.Link>
            <NavDropdownMenu className="nav-dropdown" title="Services" id="collasible-nav-dropdown">
              <NavDropdown.Item className="nav-items" href="/PersonalInsurance">Personal Short Term Insurance</NavDropdown.Item>
              <NavDropdown.Item className="nav-items" href="/CommercialBusinessInsurance">Commercial & Business Insurance</NavDropdown.Item>
              <NavDropdown.Item className="nav-items" href="/MedicalMalpractice">Medical Malpractice</NavDropdown.Item>
              <NavDropdown.Item className="nav-items" href="/HealthInsurance">Health Insurance</NavDropdown.Item>
              <NavDropdown.Item className="nav-items" href="/SpecialRisk">Special Risks</NavDropdown.Item>
              {/* <NavDropdown.Item className="nav-items" href="/LifeAndInvestment">Life & Investment</NavDropdown.Item> */}
            </NavDropdownMenu>
            {/* <Nav.Link className="nav-links" href="/Articles"  >Articles & News</Nav.Link> */}
            <Nav.Link className="nav-links" href="/ContactUs" >Contact Us</Nav.Link>


          </Nav>
        </Navbar.Collapse>

      </Navbar>

    </>
  )
};